// Central API configuration
// Auth endpoints point to local Django backend (which proxies/integrates with AdexCloud AI)
// Business endpoints stay on the local Django backend

export const AUTH_API = {
  login: "/api/auth/login/",
  logout: "/api/auth/logout/",
  signup: "/api/auth/signup/",
  me: "/api/auth/me/",
  profile: "/api/auth/profile/",
  retryOnboarding: "/api/auth/retry-onboarding/",
  globalRole: "/api/auth/global-role/",
  changePassword: "/api/auth/change-password/",
  resetPasswordRequest: "/api/auth/reset-password/request/",
  resetPasswordReset: "/api/auth/reset-password/reset/",
  totpSetup: "/api/auth/totp/setup/",
  totpDisable: "/api/auth/totp/disable/",
  totpBackupCodes: "/api/auth/totp/backup-codes/",
  totpValidate: "/api/auth/totp/validate/",
  googleInit: "/api/auth/google/init/",
  verifyEmail: "/api/auth/verify-email/",
  resendVerification: "/api/auth/resend-verification/",
};

export const ADMIN_API = {
  smtpConfig: "/api/admin/smtp-config/",
  smtpConfigUpdate: "/api/admin/smtp-config/update/",
  smtpConfigTest: "/api/admin/smtp-config/test/",
};

export const LOCAL_API = {
  // Auth endpoints that stay local (if any)
  user: "/api/auth/user/",
  tokenRefresh: "/api/token/refresh/",

  // Business endpoints
  agentsList: "/api/agents/list/",
  deployAssistant: "/api/deploy-assistant",
  testCall: "/api/agent/test-call/",
  uploadFile: "/api/upload-file/",
  companyProfile: "/api/company/",
  businessTypes: "/api/get-business-types/",
  serviceAgentTypes: "/api/get-service-agent-types/",
  wizardStatus: "/api/wizard/status/",
  twilioNumbers: "/api/get-twilio-numbers",
  workflows: "/api/workflows/",
  workflowsCreate: "/api/workflows/create/",
  knowledgeBases: "/api/knowledge-bases/",
  knowledgeBasesCreate: "/api/knowledge-bases/create/",
  sip: "/api/sip/",
  sipCreate: "/api/sip/create/",
  adminCalls: "/api/calls/",
  adminAgents: "/api/admin/agents/",
  assignWorkflow: "/api/agents/",
  assignKb: "/api/agents/",
  agentsForAssignment: "/api/agents/for-assignment/",
};
